import {useStoreServiceInputs} from "~/composables/store/services/service_inputs";
import {useStorePrice, useStorePriceLoading} from "~/composables/store/order/mainForm";
import {useStoreSelectedServiceChildren} from "~/composables/store/order/serviceForm";


export function clearCalculatorStore() {
    useStoreServiceInputs().value = []
    useStorePrice().value = 0
    useStorePriceLoading().value = false
    useStorePromoCode().value = ''
    useStoreSelectedServiceChildren().value = {}
}